import { apiInstance, gql } from "@/services/httpAdapter";

export async function createTrainingItem(locationId, commissionCycleId, input) {
	const query = gql`
		mutation createTrainingItem($locationId: String!, $commissionCycleId: String!, $input: TrainingItemInput!) {
			createTrainingItem(locationId: $locationId, commissionCycleId: $commissionCycleId, input: $input) {
				_id
				commissionCycleId
				createdAt
				createdBy {
					_id
					fullName
				}
				items {
					_id
					createdAt
					createdBy {
						_id
						fullName
					}
					effectiveDateFrom
					effectiveDateTo
					pay {
						input
						value
					}
					updatedAt
					updatedBy {
						_id
						fullName
					}
					userId {
						_id
						fullName
						employeeId
					}
				}
				updatedAt
				updatedBy {
					_id
					fullName
				}
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		input,
	};

	try {
		const { data } = await apiInstance.post("/graphql", { query, variables });
		return data?.data?.createTrainingItem;
	} catch (err) {
		throw new Error(err);
	}
}

export async function updateTrainingItem(locationId, commissionCycleId, trainingItemId, input) {
	const query = gql`
		mutation updateTrainingItem(
			$locationId: String!
			$commissionCycleId: String!
			$trainingItemId: String!
			$input: TrainingItemInput!
		) {
			updateTrainingItem(
				locationId: $locationId
				commissionCycleId: $commissionCycleId
				trainingItemId: $trainingItemId
				input: $input
			) {
				commissionCycleId
				createdAt
				createdBy {
					_id
					fullName
				}
				items {
					_id
					createdAt
					createdBy {
						_id
						fullName
					}
					effectiveDateFrom
					effectiveDateTo
					pay {
						input
						value
					}
					updatedAt
					updatedBy {
						_id
						fullName
					}
					userId {
						_id
						fullName
						employeeId
					}
				}
				updatedAt
				updatedBy {
					_id
					fullName
				}
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		trainingItemId,
		input,
	};

	try {
		const { data } = await apiInstance.post("/graphql", { query, variables });
		return data?.data?.updateTrainingItem;
	} catch (err) {
		throw new Error(err);
	}
}

// TODO correct inputs
export async function deleteTrainingItems(locationId, commissionCycleId, trainingItemIds, input = null) {
	const query = gql`
		mutation deleteTrainingItems(
			$locationId: String!
			$commissionCycleId: String!
			$trainingItemIds: [String]
			$input: TrainingItemInput
		) {
			deleteTrainingItems(
				locationId: $locationId
				commissionCycleId: $commissionCycleId
				trainingItemIds: $trainingItemIds
				input: $input
			) {
				commissionCycleId
				createdAt
				createdBy {
					_id
					fullName
				}
				items {
					_id
					createdAt
					createdBy {
						_id
						fullName
					}
					effectiveDateFrom
					effectiveDateTo
					pay {
						input
						value
					}
					updatedAt
					updatedBy {
						_id
						fullName
					}
					userId {
						_id
						fullName
						employeeId
					}
				}
				updatedAt
				updatedBy {
					_id
					fullName
				}
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		trainingItemIds,
		input,
	};

	try {
		const { data } = await apiInstance.post("/graphql", { query, variables });
		return data?.data?.deleteTrainingItems;
	} catch (err) {
		throw new Error(err);
	}
}
